import {useSelector} from 'react-redux';

function useGetMode() {
  return useSelector((state: any) => state.courseReducer.edit);
}

export default useGetMode;
